const host = "https://h0irzatkzf.execute-api.eu-north-1.amazonaws.com";
const externalHost = "https://demo.svenskafribrevsbolaget.se";
export default {
  env: "dev",
  domain: host,
  BASE_URL: `${host}/dev/`,
  S3_BASE_URL: "https://sfb-app-fs.s3.eu-north-1.amazonaws.com/",
  EXTERNAL_URL: externalHost,
  baseName: "/",
  language: "sv",
  markerDestinationId: "656ca9f7406b387c025517e7",
  sentryURL:
    "https://8e1aa1837a2b444ebfdb0af69017e508@o151669.ingest.sentry.io/6272397",
  api: {
    maxAge: 15 * 60 * 1000, // 15 minutes
  },
};
